import { useContext } from 'react';
import { ProductTemplatesContext } from '../contexts/product_templates.context';
export const useProductTemplates = () => {
    const context = useContext(ProductTemplatesContext);
    if (!context) {
        throw new Error('useProductTemplates must be used within ProductTemplatesContext');
    }
    return context;
};
